import {NgModule} from '@angular/core';
import {IonicPageModule} from 'ionic-angular';
import {NetworkButtonComponent} from './network-button';
import {Network} from '@ionic-native/network';
import {TranslateModule} from '@ngx-translate/core';

@NgModule({
  declarations: [
    NetworkButtonComponent,
  ],
  imports: [
    TranslateModule.forChild(),
    IonicPageModule.forChild(NetworkButtonComponent),
  ],
  exports: [
    NetworkButtonComponent
  ],
  providers: [
    Network
  ]
})
export class NetworkComponentModule {
}



// WEBPACK FOOTER //
// ./src/components/network-button/network-button.module.ts